import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiMinus, FiPlus, FiTrash2, FiArrowRight, FiShoppingBag } = FiIcons;

export default function CartDrawer({ isOpen, onClose, cart, updateQuantity, removeItem, onCheckout }) {
  const subtotal = cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[100]"
          />
          <motion.div 
            initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed top-0 right-0 h-full w-full max-w-md bg-white z-[110] flex flex-col shadow-2xl"
          >
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-[var(--off-white)]">
              <div>
                <h2 className="text-2xl font-bold text-[var(--navy)] italic">Workspace Kit</h2>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Circular Selection</p>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                <SafeIcon icon={FiX} className="text-xl" />
              </button>
            </div>

            <div className="flex-grow overflow-y-auto p-6 space-y-6">
              {cart.length === 0 ? (
                <div className="h-full flex flex-col items-center justify-center text-center opacity-40">
                  <div className="w-20 h-20 rounded-full bg-[var(--kraft-light)] flex items-center justify-center mb-4">
                    <SafeIcon icon={FiShoppingBag} className="text-3xl" />
                  </div>
                  <p className="font-bold uppercase tracking-widest text-xs">Your kit is empty</p>
                  <button onClick={onClose} className="mt-4 text-[var(--navy)] border-b border-[var(--navy)] font-bold text-sm">Start the Loop</button>
                </div>
              ) : (
                cart.map((item) => (
                  <div key={item.id} className="flex gap-4 group">
                    <div className="w-20 h-24 bg-[var(--kraft-light)] rounded-sm overflow-hidden flex-shrink-0">
                      <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-grow">
                      <div className="flex justify-between mb-1">
                        <h3 className="font-bold text-[var(--navy)] text-sm">{item.name}</h3>
                        <span className="font-bold text-xs">${(item.price * item.quantity).toFixed(2)}</span>
                      </div>
                      <p className="text-[10px] text-gray-400 mb-4">{item.scent || 'Standard Scent'}</p>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center border border-gray-100 rounded-sm">
                          <button onClick={() => updateQuantity(item.id, -1)} className="p-1.5 hover:text-[var(--mint-dark)]"><SafeIcon icon={FiMinus} className="text-xs" /></button>
                          <span className="px-3 text-xs font-bold">{item.quantity}</span>
                          <button onClick={() => updateQuantity(item.id, 1)} className="p-1.5 hover:text-[var(--mint-dark)]"><SafeIcon icon={FiPlus} className="text-xs" /></button>
                        </div>
                        <button onClick={() => removeItem(item.id)} className="text-gray-300 hover:text-red-400 transition-colors">
                          <SafeIcon icon={FiTrash2} className="text-sm" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

            {cart.length > 0 && (
              <div className="p-6 bg-[var(--off-white)] border-t border-gray-100">
                <div className="flex justify-between mb-2">
                  <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Subtotal</span>
                  <span className="font-bold text-[var(--navy)]">${subtotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between mb-6">
                  <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Impact</span>
                  <span className="text-xs font-bold text-[var(--mint-dark)] uppercase tracking-widest">Circular Shipping</span>
                </div>
                <button 
                  onClick={onCheckout}
                  className="w-full py-4 bg-[var(--navy)] text-[var(--mint)] font-bold rounded-sm hover:bg-[var(--navy-light)] transition-all flex items-center justify-center gap-3 shadow-xl"
                >
                  Confirm Selection <SafeIcon icon={FiArrowRight} />
                </button>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}